import assets from 'config/api/assets/assets';

const assetParamsGetter = (query: any) => [assets.autocomplete({ limit: 25, search: query })];

export default assetParamsGetter;
